module.exports = __webpack_public_path__ + "fonts/DM_Sans-200-latin-ext4.0d3827b.woff2";